import { Component, Input, OnInit } from '@angular/core';
import {RewardService} from "../../../../../shared/services/reward.service";
import {properties} from "../../../../../../environments/properties";

@Component({
  selector: 'app-promotion-info',
  templateUrl: './promotion-info.component.html',
  styleUrls: ['./promotion-info.component.scss']
})
export class PromotionInfoComponent implements OnInit {
  @Input() partnerDetails: any;
  partnerDetailContentURL: any;
  promotionDetailDataObj: any;
  showLoading: any = true;
  @Input() isWebView;
  displayableBanner: string = '';
  constructor(
    private rewardService: RewardService,
  ) { }

  ngOnInit(): void {
    if (this.partnerDetails) {
      if (this.partnerDetails.contentPath) {
        this.partnerDetailContentURL = this.partnerDetails.contentPath;
          this.displayableBanner = properties.rewardsConfig.displaybleBannerNames[this.partnerDetails.banner];
        if(this.isWebView) {
          this.partnerDetailContentURL = this.rewardService.getMobileApplicationDomainURL(this.partnerDetails.currentEnvironment, this.partnerDetails.banner) + '/' + this.partnerDetailContentURL.replace(/\{partner_section\}/g, 'intro');
        } else {
          this.partnerDetailContentURL = this.rewardService.getApplicationDomainURL() + '/' + this.partnerDetailContentURL.replace(/\{partner_section\}/g, 'intro');
        }
        this.getPartnerDetailContentAPI();
      }
    }
  }
  getPartnerDetailContentAPI(){
    this.rewardService.getPromotionDetailContent(this.partnerDetailContentURL).subscribe((promotionDetailData: any) => {
        this.showLoading = false;
        this.promotionDetailDataObj = this.rewardService.replaceBannerInContent(this.promotionDetailDataObj, this.partnerDetails.banner);
        this.promotionDetailDataObj = this.replaceADAText(promotionDetailData);
    })
  }

    replaceADAText(info: string): string {
     if(info){
        const parser = new DOMParser();
        const doc = parser.parseFromString(info, 'text/html');

        const containers = doc.querySelectorAll('div.richtext.parbase.section');
        containers.forEach(container => {
            const paragraphs = container.querySelectorAll('p');
            paragraphs.forEach((paragraph, index) => {
                const origText = paragraph.textContent?.trim();

                if(origText){
                    let formattedText = origText;
                    formattedText = this.convertPriceMonthsToWords(formattedText);
                    paragraph.setAttribute('aria-hidden', 'true');

                    const span = document.createElement('span');
                    span.classList.add('sr-only');
                    span.setAttribute('aria-hidden', 'false');
                    span.setAttribute('role', 'text');
                    span.setAttribute('aria-live','polite');
                    span.setAttribute('id',`sr-text-${index}`);
                    span.textContent = formattedText;

                    paragraph.setAttribute('aria-describedby',`sr-text-${index}`);
                    paragraph.insertAdjacentElement('afterend', span);
                }
            });
        });
        return doc.body.innerHTML;
     }

   }

   convertPriceMonthsToWords(text: string): string{
    let updatedText = text;
       updatedText =  updatedText.replace(
           /\$(\d+)\.(\d{2})\/mo\b/g,
           (_match, dollars, cents) => {
               return `${dollars} dollars, ${cents} cents per month`;
           }
       );

       updatedText = updatedText.replace(
           /\$(\d+)\.(\d{2})\/month\b/g,
           (_match, dollars, cents) => {
               return `${dollars} dollars, ${cents} cents per month`;
           }
       );

       updatedText = updatedText.replace(
           /\/mo\b/gi,
           ' per month'
       );

       updatedText = updatedText.replace(
          /\bper mo\.?\b/gi,
          ' per month'
       );

       updatedText = updatedText.replace(
          /\bmos\b/gi,
          ' months'
       );
       return updatedText;
    }

}
